import script from "./InputFormGeburtstagSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./InputFormGeburtstagSelect.vue?vue&type=script&setup=true&lang=js"

import "./InputFormGeburtstagSelect.vue?vue&type=style&index=0&id=2183a4d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2183a4d2"]])

export default __exports__